import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  OrderComponentInterface,
  OrderComponentPropertyUpdate,
  OrderCreateRequestUpdate,
} from "components/order-management/order-components-interface";
import { Order } from "models/order-management/models";
import { OrderComponent } from "models/order-management/orderComponent";
import { OrderFormState } from "./order-form-state";

@Component({
  selector: "not-implemented",
  templateUrl: "not-implemented.component.html",
})
export class NotImplemented implements OrderComponentInterface {
  @Input() orderComponent: OrderComponent;
  @Input() orderCreateRequest: Order;
  @Input() orderFormState: OrderFormState;
  @Output() orderCreateRequestEvent =
    new EventEmitter<OrderCreateRequestUpdate>();
  @Output() orderFormStateEvent = new EventEmitter<OrderFormState>();
  @Output() isValidEvent = new EventEmitter<boolean>();
  @Output() amendedOrderRequestEvent =
    new EventEmitter<OrderComponentPropertyUpdate>();
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/add-order/not-implemented.component.ts